// Converts "HH:MM" stored in Europe/Moscow (UTC+3, no DST since 2014) to client's local timezone
export const convertToLocalTime = (timeStr) => {
    if (!timeStr) return timeStr;

    const [h, m] = timeStr.split(':').map(Number);

    const d = new Date();
    d.setUTCHours(h - 3, m, 0, 0);

    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};
